/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {TableHeaderEntryModel} from '../../shared/table/models/table-header-entry.model';
import {SettlementColumnEnum} from '../models/settlement-column.enum';
import * as SettlementsMainPageDataPipes from './data-pipes/settlement-main-page-data-pipes';

const settlementsMainPageHeadersConfiguration: {
    customers: TableHeaderEntryModel<SettlementColumnEnum>;
    suppliers: TableHeaderEntryModel<SettlementColumnEnum>;
    complaint: TableHeaderEntryModel<SettlementColumnEnum>;
    settlement: TableHeaderEntryModel<SettlementColumnEnum>;
    status: TableHeaderEntryModel<SettlementColumnEnum>;
    lastPendingDate: TableHeaderEntryModel<SettlementColumnEnum>;
    lastChangeDatetime: TableHeaderEntryModel<SettlementColumnEnum>;
    materialsTotalGrossCost: TableHeaderEntryModel<SettlementColumnEnum>;
    teMinutesTotalCost: TableHeaderEntryModel<SettlementColumnEnum>;
    settlementTotalCost: TableHeaderEntryModel<SettlementColumnEnum>;
} = {
    customers: {
        code: SettlementColumnEnum.CUSTOMER,
        name: 'Customer',
        sortable: true,
        widthWeight: 7,
        dataPipe: SettlementsMainPageDataPipes.suppliersCustomersPipe,
        hasCopyPaste: true
    },
    suppliers: {
        code: SettlementColumnEnum.SUPPLIER,
        name: 'Supplier',
        sortable: true,
        widthWeight: 7,
        dataPipe: SettlementsMainPageDataPipes.suppliersCustomersPipe,
        hasCopyPaste: true
    },
    complaint: {
        code: SettlementColumnEnum.COMPLAINT_CODE,
        name: 'Complaint No.',
        sortable: true,
        widthWeight: 5,
        hasCopyPaste: true,
        dataPipe: SettlementsMainPageDataPipes.settlementComplaintCode
    },
    settlement: {
        code: SettlementColumnEnum.SETTLEMENT_CODE,
        name: 'Settlement',
        sortable: true,
        widthWeight: 5,
        hasCopyPaste: true,
        dataPipe: SettlementsMainPageDataPipes.settlementComplaintCode
    },
    status: {
        code: SettlementColumnEnum.STATUS,
        name: 'Status',
        sortable: true,
        widthWeight: 7,
        hasDot: true,
        dataPipe: SettlementsMainPageDataPipes.statusPipe,
        hasCopyPaste: true
    },
    lastPendingDate: {
        code: SettlementColumnEnum.LAST_PENDING_DATE,
        name: 'Last Pending date',
        sortable: true,
        widthWeight: 7,
        hasCopyPaste: true
    },
    lastChangeDatetime: {
        code: SettlementColumnEnum.LAST_CHANGE_DATETIME,
        name: 'Last modify',
        sortable: true,
        widthWeight: 7,
        hasCopyPaste: true
    },
    materialsTotalGrossCost: {
        code: SettlementColumnEnum.MATERIALS_TOTAL_GROSS_COST,
        name: 'Part(s) total amount',
        sortable: true,
        widthWeight: 7,
        hasTextAlignRight: true,
        dataPipe: SettlementsMainPageDataPipes.financialNumberPipe,
        hasCopyPaste: true
    },
    teMinutesTotalCost: {
        code: SettlementColumnEnum.TE_MINUTES_TOTAL_COST,
        name: 'TE minute(s) total amount',
        sortable: true,
        widthWeight: 7,
        hasTextAlignRight: true,
        dataPipe: SettlementsMainPageDataPipes.financialNumberPipe,
        hasCopyPaste: true
    },
    settlementTotalCost: {
        code: SettlementColumnEnum.SETTLEMENT_TOTAL_COST,
        name: 'Settlement total amount',
        sortable: true,
        widthWeight: 7,
        hasTextAlignRight: true,
        dataPipe: SettlementsMainPageDataPipes.financialNumberPipe,
        hasCopyPaste: true
    }
};

export default settlementsMainPageHeadersConfiguration;
